import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Nome é obrigatório'),
  url: Yup.string().required('URL é obrigatória'),
  events: Yup.array().min(1, 'Selecione pelo menos um evento'),
});

export default validationSchema;
